import { OpenWindowWithPost } from '../utils/functions'
import http from './httpService'
import { toast } from "react-toastify";

const api_url = 'https://www.skeinet.com/fake_pentagramma_api/api/';

export let system = { id: 0, year: '' }
export let currentYear = ''

function url(path){
  //A
  return api_url + path + ".php";
}

export async function getSystem()  {
  let obj = await httpPost("getCollection", { collectionName: 'system' })
  if(obj !== false){
    system = obj.data[0]
    let v = system.year.split("-")
    system.previousYear = 0
    if(v.length>=2){
      system.previousYear = (v[0]-1)+"-"+(v[1]-1)
    }
  }
  
  return system;
}

export async function changeYear(year)  {
  system.year = year
  let v = system.year.split("-")
  system.previousYear = 0
  if(v.length>=2){
    system.previousYear = (v[0]-1)+"-"+(v[1]-1)
  }
  await httpPost("putRecord", { collectionName: 'system', obj: system })
  await getSystem()
}

export async function httpGet(path) {
  try {
    const response = await http.get(url(path))
    let obj = {}
    if(response.data.result && response.data.result !== 'OK'){
      toast.error(response.data.result)
    } else {
      obj = response.data.obj
    }
    return obj
  } catch (err) {
    return false
  }
}

export async function httpPost(path, dataToSend) {
  let data= "data="+JSON.stringify(dataToSend)
  try {
    const response = await http.post(url(path), data )
    let obj = {}
    if(response.data.result && response.data.result !== 'OK'){
      toast.error(response.data.result)
      obj = false
    } else {
      obj = response.data.obj
    }
    return obj
  } catch (err) {
    return false
  }
}

export async function openPdf(path, membershipId) {
  let data = {}
  data.membershipId = membershipId
  //console.log(url(path), data)
  OpenWindowWithPost(url(path), '', 'Tesseramento', { data: JSON.stringify(data) });
}

export async function openExcel(data) {
  OpenWindowWithPost(url(data.path), '', data.title, { data: JSON.stringify(data) });
}